import { Dispatch, SetStateAction } from "react"
import { useTranslation } from "react-i18next"

import { getTraceabilityRequestsQueryParams } from "@tfg/types/schemas/traceabilityRequests"

import { SortBuilder } from "~/components/SortBuilder"
import { useGetTraceabilityRequestsIsSortableByOrderDate } from "~/pages/SupplierPortal/TraceabilityRequests/hooks/useGetTraceabilityRequestsIsSortableByOrderDate"
import { useGetTracebilityRequestsIsSortableByDueDate } from "~/pages/SupplierPortal/TraceabilityRequests/hooks/useGetTracebilityRequestsIsSortableByDueDate"

interface Props {
  sorts: Exclude<getTraceabilityRequestsQueryParams["sort"], undefined>
  setSorts: Dispatch<
    SetStateAction<
      Exclude<getTraceabilityRequestsQueryParams["sort"], undefined>
    >
  >
  filters: getTraceabilityRequestsQueryParams["filters"]
}

export const RequestSorts = ({ sorts, setSorts, filters }: Props) => {
  const { t } = useTranslation(["traceability"])

  const { data: isSortableByDueDate } =
    useGetTracebilityRequestsIsSortableByDueDate({
      filters,
    })

  const { data: isSortableByOrderDate } =
    useGetTraceabilityRequestsIsSortableByOrderDate({
      filters,
    })

  const options: {
    label: string
    value: keyof Exclude<getTraceabilityRequestsQueryParams["sort"], undefined>
  }[] = [
    { label: t("sorts.receptionDate"), value: "receptionDate" },
    { label: t("sorts.reference"), value: "reference" },
    { label: t("sorts.client"), value: "client" },
  ]

  if (isSortableByDueDate) {
    options.push({ label: t("sorts.dueDate"), value: "dueDate" })
  }

  if (isSortableByOrderDate) {
    options.push({ label: t("sorts.orderDate"), value: "orderDate" })
  }

  return (
    <SortBuilder<Exclude<getTraceabilityRequestsQueryParams["sort"], undefined>>
      options={options}
      sorts={sorts}
      setSorts={setSorts}
    />
  )
}
